exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-38ca3b51]{color:#333}.social[data-v-38ca3b51]{justify-content:flex-end!important}.social img[data-v-38ca3b51]{width:24px;height:auto;margin-left:1rem;display:block}@media only screen and (max-width:768px){.copyright[data-v-38ca3b51],.social[data-v-38ca3b51]{font-size:12px}.social img[data-v-38ca3b51]{width:18px;height:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38ca3b51","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 72
// module chunks = 0